/**
 * 网站监测模块（src/views/websiteMonitoring）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '详情': 'Details',
  '取消': 'Cancel',
  '确定': 'OK',
  '关闭': 'Close',
  '导出': 'Export',
  '下载': 'Download',
  '操作': 'Action',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '展开': 'Expand',
  '收起': 'Collapse',
  '无图片': 'No Image',
  '无文件': 'No File',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '其他': 'Other',
  '未知': 'Unknown',
  '故障': 'Fault',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '确定删除吗?': 'Are you sure you want to delete?',
  '基本信息': 'Basic Information',
  '已选择 {count} 项': '{count} items selected',
  '请设置url.list属性!': 'Please set the url.list property!',

  // ── 通用设备/查询词条 ──
  '表编号': 'Meter No.',
  '设备ID': 'Device ID',
  '设备编号': 'Device No.',
  '设备名称': 'Device Name',
  '设备类型': 'Device Type',
  '设备管理': 'Device Management',
  '安装位置': 'Installation Location',
  '表类型': 'Meter Type',
  '仪表类型': 'Instrument Type',
  '仪表电池电压(%)': 'Instrument Battery Voltage (%)',
  'GPRS电池电压(%)': 'GPRS Battery Voltage (%)',
  '软件版本号': 'Software Version',
  'SIM卡号': 'SIM Card No.',
  '上报时间': 'Report Time',
  '上传时间': 'Upload Time',
  '日期': 'Date',
  '时间': 'Time',
  '输入设备ID模糊查询': 'Enter device ID to search',
  '输入设备编号模糊查询': 'Enter device No. to search',
  '输入设备编号查询': 'Enter device No. to query',
  '输入设备名称模糊查询': 'Enter device name to search',
  '请输入表编号': 'Please enter meter No.',
  '请输入设备编号': 'Please enter device No.',
  '请输入表编号，进行查询': 'Please enter meter No. to query',
  '请选择设备类型': 'Please select device type',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '查询创建时间': 'Query Created At',
  '自定义列': 'Custom Columns',
  '下载导入模板': 'Download Import Template',
  '批量导入': 'Batch Import',
  '水质监测数据导入模板': 'Water Quality Monitoring Data Import Template',
  '模板下载失败': 'Failed to download template',
  '导入失败': 'Import failed',
  '导入成功 {count} 条': '{count} records imported successfully',
  '导入完成:成功 {success} 条,失败 {fail} 条': 'Import finished: {success} succeeded, {fail} failed',
  '文件上传失败: {name}': 'File upload failed: {name}',
  '第{row}行 设备[{device}]: {message}': 'Row {row}, device [{device}]: {message}',

  // ── 电磁流量计 ──
  '实时数据': 'Real-time Data',
  '历史数据': 'Historical Data',
  '压力值(MPa)': 'Pressure (MPa)',
  '温度值(℃)': 'Temperature (℃)',
  '温度(℃)': 'Temperature (℃)',
  '温度值': 'Temperature',
  '总累计流量(m³)': 'Total Cumulative Flow (m³)',
  '正向流量(m³)': 'Forward Flow (m³)',
  '反向流量(m³)': 'Reverse Flow (m³)',
  '总流量(m³)': 'Total Flow (m³)',
  '瞬时流量(m³)': 'Instantaneous Flow (m³)',
  '流速(m³/h)': 'Flow Rate (m³/h)',
  '管网监测-实时数据': 'Pipe Network Monitoring - Real-Time Data',
  '管网监测-历史数据': 'Pipe Network Monitoring - Historical Data',
  '压力值(MPa)/液位值(m)': 'Pressure (MPa)/Liquid Level (m)',
  '信号值': 'Signal Value',
  '电量(%)': 'Battery Level (%)',
  '电池状态': 'Battery Status',
  '欠压': 'Undervoltage',
  '上报方式': 'Report Method',
  '传感器状态': 'Sensor Status',
  '告警状态': 'Alarm Status',
  '最小值': 'Min',
  '最大值': 'Max',
  '最小值:': 'Min: ',
  '最大值:': 'Max: ',
  'NB压力表': 'NB Pressure Gauge',
  'NB液位计': 'NB Liquid Level Gauge',
  '4G压力表': '4G Pressure Gauge',
  '4G液位计': '4G Liquid Level Gauge',
  '请选择电池状态': 'Please select battery status',
  '请选择上报方式': 'Please select report method',
  '请选择传感器状态': 'Please select sensor status',

  // ── 命令服务队列 ──
  '命令标识': 'Command ID',
  '命令下发': 'Send Command',
  '命令队列': 'Command Queue',
  '命令服务队列': 'Command Service Queue',
  '通讯状态': 'Communication Status',
  '发送时间': 'Send Time',
  '回应时间': 'Response Time',
  '你确定要撤销该条记录吗?': 'Are you sure you want to revoke this record?',
  '终端参数配置': 'Terminal Parameter Configuration',
  '读取采集器NB网络参数': 'Read Collector NB Network Parameters',
  '读取上传间隔': 'Read Upload Interval',
  '读取自动上传时间点': 'Read Auto Upload Time Points',
  '设置采集器NB网络参数': 'Set Collector NB Network Parameters',
  '设置阀门角度': 'Set Valve Angle',
  '阀门角度校正': 'Valve Angle Calibration',
  '设置上传间隔': 'Set Upload Interval',
  '设置自动上传时间点': 'Set Auto Upload Time Points',
  '设置采集器阀门控制': 'Set Collector Valve Control',
  '请选择命令标识': 'Please select command ID',
  '请选择通讯状态': 'Please select communication status',

  // ── 阀门开度 ──
  '阀门开度': 'Valve Opening',
  '阀门状态': 'Valve Status',
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '电压(V)': 'Voltage (V)',

  // ── 水质监测 ──
  '污染物因子': 'Pollutant Factor',
  'PH值': 'pH',
  '色度': 'Chroma',
  '浑浊度': 'Turbidity',
  '浑浊度(NTU)': 'Turbidity (NTU)',
  '溶解性总固体': 'Total Dissolved Solids',
  '溶解性总固体(mg/L)': 'Total Dissolved Solids (mg/L)',
  '硬度': 'Hardness',
  '硬度(mg/L)': 'Hardness (mg/L)',
  '氯化物': 'Chloride',
  '氯化物(mg/L)': 'Chloride (mg/L)',
  '余氯': 'Residual Chlorine',
  '余氯(mg/L)': 'Residual Chlorine (mg/L)',
  '硫酸盐': 'Sulfate',
  '硫酸盐(mg/L)': 'Sulfate (mg/L)',
  '电导率': 'Conductivity',
  '电导率(μS/cm)': 'Conductivity (μS/cm)',
  'ORP': 'ORP',
  'ORP(mv)': 'ORP (mV)',
  '录入': 'Entry',
  '编辑标准': 'Edit Standard',
  '污染因子分析': 'Pollutant Factor Analysis',
  '平均值': 'Average',
  '实时值': 'Real-Time Value',

  // ── 井电双控 ──
  '井电双控-实时数据': 'Well-Electricity Dual Control - Real-Time Data',
  '井电双控-历史数据': 'Well-Electricity Dual Control - Historical Data',
  '水利编号': 'Water Conservancy No.',
  '状态': 'Status',
  '关泵': 'Pump Off',
  '在线抽水中': 'Pumping (Online)',
  '报警状态': 'Alarm Status',
  '综合保护器报警': 'Comprehensive Protector Alarm',
  '有脉冲干扰': 'Pulse Interference',
  '断线报警': 'Disconnection Alarm',
  '最后通讯时间': 'Last Communication Time',
  '箱门状态': 'Cabinet Door Status',
  '箱门关闭': 'Door Closed',
  '箱门开启': 'Door Open',
  '剩余水量(m³)': 'Remaining Water (m³)',
  '总用水量(m³)': 'Total Water Use (m³)',
  '取水证号及电子证号': 'Water Withdrawal Permit No. & E-Permit No.',
  '计量方式(m³/h)': 'Metering Method (m³/h)',
  '井地址': 'Well Address',

  // ── 太阳能设备 ──
  '用电数据': 'Electricity Data',
  '用电历史数据': 'Electricity Historical Data',
  '状态信息': 'Status Information',
  '数据图形展示': 'Data Chart',
  '数据列表': 'Data List',
  '今日': 'Today',
  '近三天': 'Last 3 Days',
  '近一周': 'Last 7 Days',
  '当月累计充电量(KWH)': 'Monthly Charging Capacity (kWh)',
  '当月累计用电量(KWH)': 'Monthly Electricity Consumption (kWh)',
  '昨日充电量(KWH)': 'Yesterday Charging Capacity (kWh)',
  '昨日用电量(KWH)': 'Yesterday Electricity Consumption (kWh)',
  '蓄电池信息': 'Battery Information',
  '充电信息': 'Charging Information',
  '放电信息': 'Discharging Information',
  '蓄电池剩余电量': 'Battery Remaining Charge',
  '蓄电池电压': 'Battery Voltage',
  '蓄电池电流': 'Battery Current',
  '蓄电池功率': 'Battery Power',
  '蓄电池状态': 'Battery Status',
  '负载电压': 'Load Voltage',
  '负载电流': 'Load Current',
  '负载功率': 'Load Power',
  '充电设备状态': 'Charging Device Status',
  '放电设备状态': 'Discharging Device Status',
  '压力状态': 'Pressure Status',
  '温度状态': 'Temperature Status',
  '超压(过压保护)': 'Overvoltage (Overvoltage Protection)',
  '过放': 'Over-discharged',
  '高温保护': 'High Temperature Protection',
  '充电状态': 'Charging Status',
  '未充电': 'Not Charging',
  '浮充': 'Float Charging',
  '强充': 'Boost Charging',
  '均衡充': 'Equalized Charging',
  '正在充电': 'Charging',
  '昼夜状态': 'Day/Night Status',
  '白天': 'Daytime',
  '夜晚': 'Night',
  '是否使用': 'In Use',
  '设备状态': 'Device Status',
  '充电过温': 'Charging Over-temperature',
  '是否放电': 'Discharging',
  '未放电': 'Not Discharging',
  '正在放电': 'Discharging Now',
  '是否硬件保护': 'Hardware Protection',
  '硬件保护': 'Hardware Protected',
  '是否开路保护': 'Open Circuit Protection',
  '开路保护': 'Open Circuit Protected',
  '是否过温': 'Over-temperature',
  '放电过温': 'Discharging Over-temperature',
  '是否短路保护': 'Short Circuit Protection',
  '短路保护': 'Short Circuit Protected',
  '设备输出功率': 'Device Output Power',
  '轻载': 'Light Load',
  '中度': 'Medium Load',
  '额定': 'Rated Load',
  '过载': 'Overload',
  '充电曲线图': 'Charging Curve',
  '放电曲线图': 'Discharging Curve',
  '上限值': 'Upper Limit',
  '下限值': 'Lower Limit',
}
